import React, { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import moment from 'moment';
import { BACKEND_URL } from '../config/constants';

const PdfAltaMedicaParticular = ({ title, list, theme }) => {
  const componentRef = useRef();
  const textIcon = (theme === 'dark' ? '_dark' : '');

  const handlePrint = useReactToPrint({
    documentTitle: 'Relatório Monitoramento Alta Médica Particular',
    content: () => componentRef.current,
  });

  return (
    <>
      <button className={'buttonIcon ' + theme} onClick={handlePrint}><img src={"/img/icon_printer" + textIcon + ".svg"} alt="" /></button>
      <div style={{ display: 'none' }}>
        <div ref={componentRef} style={{ width: '100%', height: window.innerHeight }}>
          <div className='inforow' style={{ marginTop: '40px', marginLeft: '80px', marginRight: '80px' }}>
            <div className="inforow right">
              <h3 style={{ fontSize: '20px' }}>{title}</h3 >
            </div>
            <div className="inforow left">
              <img src="/img/logo_powered_insightcare.png" alt="Insightcare" style={{ width: '12vw', position: 'relative', marginLeft: '32px', float: 'right' }} />
              {
                BACKEND_URL.includes('gruposanta') ? (
                  <img src="/img/logo_gruposanta.png" alt="Gruposanta" style={{ width: '12vw', position: 'relative', float: 'right', marginLeft: '25px' }} />
                ) : null
              }
            </div>
          </div>
          <div className="inforow" style={{ marginLeft: '80px', marginRight: '80px' }}>
            <div className='inforow right'>
              <div className='infoText' style={{ fontSize: '12px' }}>Mostrando {list.length} pacientes </div>
            </div>
            <div className='inforow left'>
              <div className='infoText' style={{ fontSize: '12px' }}>Impresso em {moment().format('HH:mm, [dia] D [de] MMMM [de] YYYY')}</div>
            </div>
          </div>
          <div className='tablePDF'>
            <table>
              <thead>
                <tr>
                  <th>Status</th>
                  <th>Leito</th>
                  <th>Paciente</th>
                  <th>Solicitante</th>
                  <th>Pedido </th>
                  <th>Tempo</th>
                </tr>
              </thead>
              <tbody>
                {list.map((data) => {
                  let key = data.CODIGOATENDIMENTO;
                  let status = "-";
                  let color = '';
                  let statusClass = "ready";
                  let tdClassRx = "";
                  let spanClassRx = "";
                  let tdClassFarm = "";
                  let spanClassFarm = "";
                  let name = data.NOMEPACIENTE.split(' ').slice(-1).join(' ') + ', ' + data.NOMEPACIENTE.split(' ')[0].slice(0, 1);

                  spanClassFarm = "success-circle";
                  status = "Transferência";
                  if (data.ALTA) {
                    status = 'Alta Hospitalar';
                    //statusClass="waiting";
                  } else {
                    if (data.ALTAMEDICA) {
                      status = 'Alta Médica';
                      //  color='red';
                      // spanClassFarm="attention-circle";
                      statusClass = "waiting";
                    }
                  }

                  let time = data.MINUTOS;
                  if (data.MINUTOS != 0) {
                    var hours = (data.MINUTOS / 60);
                    if (hours < 0) {
                      hours = hours * -1;
                    }
                    var rhours = Math.floor(hours);

                    var minutes = (hours - rhours) * 60;
                    var rminutes = Math.round(minutes);
                    time = rhours + " hs " + rminutes + " mins";
                  } else {
                    time = time + ' mins';
                  }
                  spanClassFarm = "attention-circle";
                  // time ='há '+time;
                  if (data.MINUTOS < 0) {

                    time = 'em ' + time;
                    spanClassFarm = "success-circle";
                  }
                  if (data.TIPOCONVENIO === 'P') {
                    color = 'red';
                  }

                  return (
                    <tr key={key} className={statusClass}>
                      <td style={{ overflow: 'hidden', whiteSpace: 'nowrap' }} align="left"><b>{status}</b></td>
                      <td style={{ overflow: 'hidden', whiteSpace: 'nowrap', color: color }} align="left"><b>{name}</b>  ({data.CODIGOATENDIMENTO})</td>
                      <td style={{ overflow: 'hidden', whiteSpace: 'nowrap', color: color }} align="left">{data.CONVENIO}</td>
                      <td style={{ color: color }} align="left"><b>{data.UNIDADE}</b></td>
                      <td style={{ color: color }} align="left"><b>{data.LEITO}</b></td>
                      <td className={tdClassFarm} align="left"><span className={spanClassFarm}></span>{time}</td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default PdfAltaMedicaParticular;